module.exports = __webpack_public_path__ + "static/main-250-af74af4ff8189c8f88bff140d2e5bf2c.png";